import React, { PureComponent } from 'react';
import Swatches from '../standardAttributes/Swatches';
import { updateUprightPosition } from '../../../helper/scene';
import { BACKSTOP_OFFSET } from '../../../constants';

export default class Uprights extends PureComponent {
  updateState = (value, importState, newAppState) => {
    const {
      appApi,
      actions,
      claraApi,
      activeTab,
      attributeName,
      configuration,
    } = this.props;
    newAppState = actions.addModel(
      importState,
      {
        tab: activeTab,
        attribute: attributeName,
        value,
        parent: configuration.base.modelId,
      },
      newAppState
    );
    newAppState = actions.setConfiguration(
      {
        attribute: attributeName,
        value: { ...importState, value },
      },
      newAppState
    );
    const heightOption = appApi.config.getAttributeAvailableValues(
      'uprightPosition',
      newAppState.configuration
    );
    if (heightOption.length) {
      newAppState = actions.setConfiguration(
        {
          attribute: 'uprightPosition',
          value: {
            value: appApi.config.getAttribute('uprightPosition').defaultValue,
          },
        },
        newAppState
      );
      updateUprightPosition(claraApi, newAppState);
      appApi.model.updateBlocks(
        importState.modelId,
        newAppState.configuration[attributeName].blocks
      );
    }
    const backstop = configuration.belowPopularBackstop.value;
    if (backstop && backstop !== 'None') {
      const { height } = appApi.config.getProduct(backstop);
      newAppState.configuration[attributeName].blocks.uprightFront.deleteRows(
        height - BACKSTOP_OFFSET
      );
    }
    return newAppState;
  };

  render() {
    return (
      <Swatches
        {...this.props}
        updateState={this.updateState}
        orientation="vertical"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/Uprights.js